/**
 * The player is in exactly ONE mode at a time (Tom, 2026-09-21: "We can ONLY
 * be in one of the 3 modes at a time").
 *
 * The three modes are the main flow, Listening and Script. Pronunciation is a
 * fourth surface of the same kind and obeys the same rule. Each one is held in
 * the player as its own boolean, which is how two of them once managed to be
 * true at once — SCRIPT mode opened over a live main-flow screen, its course
 * header and play bar still on top of the canvas.
 *
 * So the flags are never written by hand any more: a mode is CHOSEN here, and
 * the full set of booleans falls out of that one choice.
 */
export type PlayerMode = 'main' | 'listening' | 'pronunciation' | 'script'

export interface ModeFlags {
  listening: boolean
  pronunciation: boolean
  script: boolean
}

/** The one true set of flags for a mode — every other combination is a bug. */
export const flagsForMode = (mode: PlayerMode): ModeFlags => ({
  listening: mode === 'listening',
  pronunciation: mode === 'pronunciation',
  script: mode === 'script',
})

/** Which mode a set of flags is in. Two flags up is impossible by construction above. */
export const modeOfFlags = (flags: ModeFlags): PlayerMode =>
  flags.listening ? 'listening'
  : flags.pronunciation ? 'pronunciation'
  : flags.script ? 'script'
  : 'main'

/** True while a mode owns the screen — the main course chrome must be gone. */
export const ownsTheScreen = (flags: ModeFlags): boolean => modeOfFlags(flags) !== 'main'
